import { render, staticRenderFns } from "./EmployeesComponent.vue?vue&type=template&id=5789da78&"
import script from "./EmployeesComponent.vue?vue&type=script&lang=js&"
export * from "./EmployeesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports